import React from 'react';
import { useMutation, useApolloClient } from '@apollo/client';
import SaveMacroMutation from './SaveMacroMutation';
import DietSettingsQuery from '../../DietSettings/Fetch/DietSettingsQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';

interface ISaveMacroConnectorApolloProps {
  children: ({ saveMacro }: { saveMacro: (input: any) => Promise<any> }) => React.ReactElement;
  post: any;
}

const SaveMacroConnectorApollo: React.FC<ISaveMacroConnectorApolloProps> = ({ children, post }) => {
  const client = useApolloClient();
  const [saveMacroMutation] = useMutation(SaveMacroMutation);

  const saveMacro = async (input: any) => {
    const date = formatIsoDate(new Date());

    const response = await saveMacroMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: DietSettingsQuery,
          variables: {
            date,
          },
        },
      ],
    });

    const serializedState = client.cache.extract();
    const trackerListKeys = Object.keys(serializedState).filter((item) =>
      item.includes('DailyTrackerData')
    );

    trackerListKeys.forEach((key) => {
      client.cache.evict({
        id: key,
      });
    });
    client.cache.gc();

    // broadcast channel
    if (post) {
      post('reload');
    }

    return response.data.dailyTracker.settings;
  };
  return children({ saveMacro });
};

export default SaveMacroConnectorApollo;
